<div id="login">
  
    <div class="page">

     

        <div class="containerP">
         
            <div class="left">
                <div class="row form" style="font-size: 12px; margin: 0px !important;">
                    <form class="matPersonalizado" [formGroup]="formLogin" (ngSubmit)="login()"
                        style="width: 100% !important; margin-top: 10%;">
                        <div style="text-align: center;">
                        <img src="../../../../../assets/images/LogoCMQCH.png" width="160px" height="90px"  alt="" class="img-fluid">
                    </div>
                    <br>
                        <div class="text-6xl font-bold leading-none text-blue">
                            <div> Ingresar a la encuesta</div>
                        </div>
                        <br>

                        <mat-form-field appearance="outline" class="col-md-12" tourAnchor="correo">
                            <mat-label>Correo</mat-label>
                            <input autocomplete="off" matInput   formControlName="correo" style="color: black !important;">
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="col-md-12" tourAnchor="identidad">
                            <mat-label># colegiación</mat-label>
                            <input autocomplete="off" matInput   formControlName="noColegiacion" style="color: black !important;">
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="col-md-12" tourAnchor="identidad">
                            <mat-label>Celular</mat-label>
                            <input autocomplete="off" matInput   formControlName="telefonoMovil" style="color: black !important;">
                        </mat-form-field>



                        <div class="text-center col-12" style="margin-top: 20px;">
                            <button style="width: 50%; background-color: rgba(32,30,30); color: white;  border-radius: 25px;
                            padding: 5px;" type="submit"
                                class="text-center" mat-raised-button>Entrar</button>
                        </div>
                    </form>


                </div>

            </div>
            
            <div class="right">
                <div class="login"><br><br></div>
                 <div class="eula">
                    <img src="../../../../../assets/images/LogoCMQCH.png" alt="" class="img-fluid">
                </div> 
            </div>
        </div>


     
    </div>

</div>